import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { open } from 'store/modules/modal';
import ModalRoot from 'components/Modal/ModalRoot';
import Experience from '../containers/Experience';
import Uploader from '../containers/Uploader';
import Messages from '../containers/Messages';

export class Mam extends Component {
  handleAddFile = file => {
    this.props.createEncoding(this.props.match.params.id, file);
  };

  render() {
    const { classes, add, cancel, clientName, messages } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.titleContainer}>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {clientName}
          </Typography>
        </div>

        <Grid container spacing={3}>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper className={classes.paper} elevation={0}>
                  <Uploader
                    handleAddFile={() => add()}
                    handleErrorMessage={message => {
                      this.props.dispatch(
                        open({
                          modalType: 'error',
                          modalProps: {
                            message,
                          },
                        })
                      );
                    }}
                    handleCancel={() => cancel()}
                  />
                </Paper>
              </Grid>
              {messages && messages.length > 0 && (
                <Grid item xs={12}>
                  <Paper className={classes.paper} elevation={0}>
                    <Messages messages={messages} />
                  </Paper>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <Experience
              handleAddExperience={() => {
                this.setState({ status: 'inserting' });
              }}
              addButtonDisabled={false}
            />
          </Grid>
        </Grid>

        <ModalRoot />
      </div>
    );
  }
}

Mam.propTypes = {
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  messages: PropTypes.array,
};

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    // backgroundColor: '#350',
  },
  leftContainer: {
    flexGrow: 3,
    paddingRight: 5,
    // backgroundColor: '#350',
  },
  rightContainer: {
    flexGrow: 1,
    paddingLeft: 5,
    // backgroundColor: '#350',
  },
  paper: {
    padding: 10,
  },
  libraryContainer: {
    height: '40vh',
  },
  paperTopPadding: {
    marginTop: 10,
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    paddingBottom: theme.spacing(),
  },
  campaignLeftContainer: {
    backgroundColor: '#ff0',
  },
  campaignRightContainer: {
    backgroundColor: '#f00',
  },
});

export default withStyles(styles)(Mam);
